"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { filterOptionsByLabel } from './utils.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, key + "" , value);
class ReferenceRecordsOptionsFactory {
  constructor(params) {
    __publicField(this, "params", params);
  }
  async getOptions({ input }) {
    return this.getOptionsSync({ input });
  }
  getOptionsSync({ input }) {
    const options = [];
    if (this.params.schema.referenceRecords && Array.isArray(this.params.schema.referenceRecords)) {
      this.params.schema.referenceRecords.map((record) => {
        if (typeof record == "object" && record.id !== void 0) {
          options.push({
            label: record.name ?? record.id,
            value: record.id,
            iconType: SvgIconType.ListOption
          });
        }
      });
    }
    const filteredOptions = filterOptionsByLabel(options, input);
    if (filteredOptions.length > 0) {
      return [
        {
          label: "Possible Values",
          isSection: true,
          iconUri: this.params.iconUri
        },
        ...filteredOptions
      ];
    } else {
      return [];
    }
  }
}

export { ReferenceRecordsOptionsFactory };
